export const EXPAND_ALL_GROUPS = 'EXPAND_ALL_GROUPS';
export const EXPAND_ALL_MATCHES = 'EXPAND_ALL_MATCHES';



// WEBPACK FOOTER //
// ./js/actions/Expand.js